export default __webpack_public_path__ + "static/media/CCTV.3c8456b3.png";